export type AddressPayload = {
  line1: string;
  line2?: string;
  city: string;
  state: string;
  zip: string;
};

const API_BASE = import.meta.env.VITE_API_BASE_URL || "";

export async function validateAddress(address: AddressPayload) {
  const response = await fetch(`${API_BASE}/api/validate-address`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ address })
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.detail || "Address validation failed");
  }

  return response.json();
}

export async function submitForm(payload: any) {
  const response = await fetch(`${API_BASE}/api/submit`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.detail || "Submission failed");
  }

  return response.json();
}
